import React from 'react';
import { XIcon } from 'lucide-react';
import { useCart } from '../context/CartContext';
import { CartItem } from './CartItem';
import { useNavigate } from 'react-router-dom';
export const Cart: React.FC = () => {
  const {
    items,
    isCartOpen,
    closeCart,
    totalItems,
    totalPrice,
    clearCart
  } = useCart();
  const navigate = useNavigate();
  if (!isCartOpen) return null;
  const handleCheckout = () => {
    closeCart();
    navigate('/checkout');
  };
  return <div className="fixed inset-0 z-50 overflow-hidden" data-id="element-10">
      <div className="absolute inset-0 overflow-hidden" data-id="element-11">
        <div className="absolute inset-0 bg-gray-500 bg-opacity-75 transition-opacity" onClick={closeCart} data-id="element-12" />
        <div className="fixed inset-y-0 right-0 flex max-w-full pl-10" data-id="element-13">
          <div className="w-screen max-w-md transform transition ease-in-out duration-300" data-id="element-14">
            <div className="flex h-full flex-col overflow-y-scroll bg-white shadow-xl" data-id="element-15">
              <div className="flex-1 overflow-y-auto py-6 px-4 sm:px-6" data-id="element-16">
                <div className="flex items-start justify-between" data-id="element-17">
                  <h2 className="text-lg font-medium text-gray-900" data-id="element-18">
                    Shopping cart
                  </h2>
                  <div className="ml-3 flex h-7 items-center" data-id="element-19">
                    <button type="button" className="-m-2 p-2 text-gray-400 hover:text-gray-500" onClick={closeCart} data-id="element-20">
                      <span className="sr-only" data-id="element-21">Close panel</span>
                      <XIcon className="h-6 w-6" aria-hidden="true" data-id="element-22" />
                    </button>
                  </div>
                </div>
                <div className="mt-8" data-id="element-23">
                  {items.length > 0 ? <div className="flow-root" data-id="element-24">
                      <ul className="-my-6 divide-y divide-gray-200" data-id="element-25">
                        {items.map(item => <li key={item.id} className="py-2" data-id="element-26">
                            <CartItem item={item} data-id="element-27" />
                          </li>)}
                      </ul>
                    </div> : <div className="text-center py-12" data-id="element-28">
                      <p className="text-gray-500" data-id="element-29">Your cart is empty</p>
                      <button onClick={closeCart} className="mt-4 text-fuchsia-600 hover:text-fuchsia-500 font-medium" data-id="element-30">
                        Continue Shopping
                      </button>
                    </div>}
                </div>
              </div>
              {items.length > 0 && <div className="border-t border-gray-200 py-6 px-4 sm:px-6" data-id="element-31">
                  <div className="flex justify-between text-base font-medium text-gray-900" data-id="element-32">
                    <p data-id="element-33">
                      Subtotal ({totalItems}{' '}
                      {totalItems === 1 ? 'item' : 'items'})
                    </p>
                    <p data-id="element-34">${totalPrice.toFixed(2)}</p>
                  </div>
                  <p className="mt-0.5 text-sm text-gray-500" data-id="element-35">
                    Shipping and taxes calculated at checkout.
                  </p>
                  <div className="mt-6" data-id="element-36">
                    <button onClick={handleCheckout} className="w-full flex justify-center items-center px-6 py-3 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-fuchsia-600 hover:bg-fuchsia-700" data-id="element-37">
                      Checkout
                    </button>
                  </div>
                  <div className="mt-6 flex justify-between" data-id="element-38">
                    <button type="button" className="text-sm font-medium text-fuchsia-600 hover:text-fuchsia-500" onClick={closeCart} data-id="element-39">
                      Continue Shopping
                    </button>
                    <button type="button" className="text-sm font-medium text-gray-500 hover:text-gray-700" onClick={clearCart} data-id="element-40">
                      Clear Cart
                    </button>
                  </div>
                </div>}
            </div>
          </div>
        </div>
      </div>
    </div>;
};